import { render, staticRenderFns } from "./couponInfo.vue?vue&type=template&id=c4ec2b36"
import script from "./couponInfo.vue?vue&type=script&lang=js"
export * from "./couponInfo.vue?vue&type=script&lang=js"
import style0 from "./couponInfo.vue?vue&type=style&index=0&id=c4ec2b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports